import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Link } from "react-router-dom";
import { getCategoryDefaultImage } from "@/utils/imageUtils";

interface LinkPreviewCardProps {
  keyword: string;
  targetUrl: string;
  targetTitle: string | null;
  targetImage: string | null;
  targetType?: string | null;
  children: React.ReactNode;
}

/** Returns true only for images that will actually load */
function isUsableImage(url: string | null | undefined): boolean {
  if (!url) return false;
  if (url.startsWith("/src/")) return false;
  if (url.startsWith("/default-")) return false;
  if (url.includes("oaidalleapiprodscus.blob.core.windows.net")) return false;
  if (!url.startsWith("http")) return false;
  return true;
}

/** Derive a category hint from the target URL for fallback images */
function categoryFromUrl(url: string): string {
  if (url.includes("/trainer/")) return "trainer";
  if (url.includes("/nutritionist/")) return "nutritionist";
  if (url.includes("/physiotherapist/")) return "physiotherapist";
  return "gym";
}

export const LinkPreviewCard = ({ keyword, targetUrl, targetTitle, targetImage, targetType, children }: LinkPreviewCardProps) => {
  const usable = isUsableImage(targetImage);
  const imgSrc = usable ? targetImage! : getCategoryDefaultImage(targetType || categoryFromUrl(targetUrl));

  return (
    <HoverCard openDelay={300} closeDelay={100}>
      <HoverCardTrigger asChild>
        <Link
          to={targetUrl}
          className="text-primary underline decoration-primary/40 hover:decoration-primary transition-colors"
          title={targetTitle || keyword}
        >
          {children}
        </Link>
      </HoverCardTrigger>
      <HoverCardContent className="w-72 p-3" side="top">
        <div className="flex gap-3">
          <img
            src={imgSrc}
            alt={targetTitle || keyword}
            className="w-16 h-16 rounded-md object-cover flex-shrink-0"
            loading="lazy"
          />
          <div className="min-w-0">
            <p className="font-semibold text-sm truncate">{targetTitle || keyword}</p>
            <p className="text-xs text-muted-foreground truncate mt-1">{targetUrl}</p>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
